var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user tw-flex tw-items-center"},[_c('div',{staticClass:"user_avatar"},[_c('chat-window-avatar',{attrs:{"src":_vm.room.avatarUrl}})],1),_c('p',{staticClass:"user_name tw-text-14px"},[_vm._v(_vm._s(_vm.room.mobile))])])}
var staticRenderFns = []

export { render, staticRenderFns }